const main_state = {
  info: false,
  loader: false,
  active_tab: "spin",
  winners: false,
  config: false,
  missions: false,
  is_share_finished: false,
  prizes: false,
  transify: false,
  is_spining: false,
  spin_prize: {
    item_name: "",
    item_img: "",
    item_num: 0,
    is_grandprize: 0, // 0 = in-game, 1 = pyshical
  },
  history: false,
};

const main = (state = main_state, action) => {
  switch (action.type) {
    case "PUT_DATA":
      return { ...state, [action.key]: action.data };
    case "TOGGLE_LOADER":
      return { ...state, loader: action.data };
    case "SELECT_TAB":
      return { ...state, active_tab: action.data };
    case "SET_INFO":
      return {
        ...state,
        info: action.data.player,
        config: action.data.common_config,
        missions: action.data.missions,
        prizes: action.data.rewards,
        transify: action.data.transify,
      };
    default:
      return state;
  }
};

export default main;
